import {
  useFlags as useLdFlags,
  useLDClient,
} from "launchdarkly-react-client-sdk";

export function useFlags() {
  const client = useLDClient();
  const flags = useLdFlags();
  const flagsHaveArrived = Boolean(client);

  if (!flagsHaveArrived) {
    return { loadingConfig: true };
  }

  return { loadingConfig: false, flags: flags };
}

export default useFlags;
